import {
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  HStack,
  Icon
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { MaintenanceFooter } from '../MaintenanceFooter';
import {
  ArrowUpDownIcon,
  TriangleDownIcon,
  TriangleUpIcon
} from '@chakra-ui/icons';
import { QuerySignagesApi } from '../../../../apis/QueryMaintenance.api';
import { SignageSearchCondition } from '../../../../pages/SignageMaintenance';

export interface SignagesType {
  id: number;
  station_cd: number;
  station_name: string;
  inbound: boolean;
  course: string;
}

const TableColumnEnum = {
  id: 'id',
  station_name: 'station_name',
  inbound: 'inbound',
  course: 'course'
};

interface props {
  SignageDatas: SignagesType[] | undefined | null;
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<SignagesType[] | undefined | null>
  >;
  Query: SignageSearchCondition;
  setQuery: React.Dispatch<React.SetStateAction<SignageSearchCondition>>;
  searchSwitch: boolean;
}

const headers = [
  { label: 'ID', key: 'id' },
  { label: '電停コード', key: 'station_cd' },
  { label: '接地箇所', key: 'station_name' },
  { label: 'INBOUD', key: 'inbound' },
  { label: 'コース', key: 'course' }
];

const GetCsvFileName = () => {
  const date = new Date();
  const hour =
    date.getMonth().toString().length === 1
      ? '0' + (date.getMonth() + 1).toString()
      : date.getMonth().toString();
  const day =
    date.getDate().toString().length === 1
      ? '0' + date.getDate().toString()
      : date.getDate().toString();
  return 'signages-' + date.getFullYear() + '-' + hour + '-' + day;
};

const SERVER_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_UI_SIGNAGE_URL + 'signage'
    : `${process.env.REACT_APP_PROTOCOL}://${window.location.hostname}:${process.env.REACT_APP_PORT_SIGNAGE}/signage`;

export const MaintenanceSignageTable: React.FC<props> = (props) => {
  const { SignageDatas, setMaintenanceDatas, Query, setQuery, searchSwitch } =
    props;
  const [pageNow, setPageNow] = useState<number>(1);
  const [columnSortType, setColumnSortType] = useState<{
    key: string;
    sort: boolean;
  }>({ key: '', sort: false });
  const pageDispMax = 30;
  const pageMax = 6;
  const csvFileName = GetCsvFileName();
  const GetPageCount = (): number => {
    if (SignageDatas !== undefined && SignageDatas !== null) {
      const divisionCount = Math.floor(SignageDatas.length / pageDispMax);
      const remCount = SignageDatas.length % pageDispMax === 0 ? 0 : 1;
      return divisionCount + remCount;
    }
    return 1;
  };
  const ColumnNameTriangleType = (column: string) => {
    if (columnSortType.key === column) {
      if (columnSortType.sort) {
        return TriangleUpIcon;
      } else {
        return TriangleDownIcon;
      }
    }
    return ArrowUpDownIcon;
  };

  const ColumnSortApi = async (column: string) => {
    const params = new URLSearchParams();
    const sortType = !columnSortType.sort;
    params.append('order', column + (sortType ? '_asc' : '_desc'));
    Query.course !== '' && params.append('course_contains', Query.course);
    Query.inbound !== '' && params.append('inbound_flg_eq', Query.inbound);
    const query = '/?' + params.toString();

    setQuery((pre) => ({ ...pre, sort: { key: column, sortType: sortType } }));
    const response = await QuerySignagesApi(query);
    if (response.success && response.data !== null) {
      setMaintenanceDatas(response.data);
      setColumnSortType({ key: column, sort: sortType });
    } else {
      alert(column + 'のソートに失敗しました。');
    }
  };

  useEffect(() => {
    setPageNow(1);
  }, [searchSwitch]);

  return (
    <>
      <TableContainer
        position='absolute'
        h='100%'
        w='100%'
        ml={5}
        overflowY='auto'
        gridRow='2/3'
        gridColumn='1/2'
        overflowX='unset'
      >
        <Table variant='simple'>
          <Thead borderWidth='1px' position='sticky' top={0} zIndex='docked'>
            <Tr bg='gray.800'>
              <Th
                cursor='pointer'
                textAlign='center'
                borderWidth='1px'
                color='white'
                onClick={() => ColumnSortApi(TableColumnEnum.id)}
              >
                <HStack>
                  <label style={{ cursor: 'pointer' }}>ID</label>
                  <Icon
                    ml={1}
                    as={ColumnNameTriangleType(TableColumnEnum.id)}
                  />
                </HStack>
              </Th>
              <Th textAlign='center' borderWidth='1px' color='white'>
                <HStack>
                  <label>設置箇所</label>
                </HStack>
              </Th>
              <Th textAlign='center' borderWidth='1px' color='white'>
                <HStack>
                  <label>コース</label>
                </HStack>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {SignageDatas !== undefined &&
              SignageDatas !== null &&
              SignageDatas.map((data, i) => {
                if (
                  pageDispMax * pageNow - pageDispMax <= i &&
                  i < pageDispMax * pageNow
                ) {
                  return (
                    <Tr key={`${'signage_' + i}`}>
                      <Td>{data.id}</Td>
                      <Td>
                        <a
                          target='_blank'
                          href={
                            SERVER_URL +
                            '/' +
                            data.station_cd.toString() +
                            '?inbound=' +
                            (data.inbound ? 'true' : 'false')
                          }
                          rel='noreferrer'
                        >
                          {`${
                            data.station_name +
                            (data.inbound ? '(上り)' : '(下り)')
                          }`}
                        </a>
                      </Td>
                      <Td>{data.course}</Td>
                    </Tr>
                  );
                }
              })}
          </Tbody>
        </Table>
      </TableContainer>
      <MaintenanceFooter
        CsvData={SignageDatas !== undefined ? SignageDatas : []}
        DataLength={SignageDatas?.length}
        Headers={headers}
        CsvFileName={csvFileName}
        GetPageCount={GetPageCount}
        pageMax={pageMax}
        pageNow={pageNow}
        setPageNow={setPageNow}
      />
    </>
  );
};
